import Types from '../types'

const initialState = {
    selectedService: '',
    selectedCredential: null,
    newProvision: null,
    tfToJson: null,
    allServices: [],
    terraformPlan: null,
    terraformApply: null,
    region: '',
    allProvisions: [],
    logs: null,
    allCostAndSecurity: null,
};
export default function provisionReducer(state = initialState, action) {
    switch (action.type) {
        case Types.PROVISION_SELECTED_CREDENTIAL:
            return {
                ...state,
                selectedCredential: action.payload
            };
        case Types.PROVISION_SELECTED_SERVICE:
            return {
                ...state,
                selectedService: action.payload
            };
        case Types.TF_TO_JSON:
            return {
                ...state,
                tfToJson: action.payload
            };
        case Types.ALL_SERVICES:
            return {
                ...state,
                allServices: action.payload
            };
        case Types.PLAN_TERRAFORM:
            return {
                ...state,
                terraformPlan: action.payload
            };
        case Types.APPLY_TERRAFORM:
            return {
                ...state,
                terraformApply: action.payload
            };
        case Types.TERRAFORM_REGION:
            return {
                ...state,
                region: action.payload
            };
        case Types.PROVISION_ALL_OPERATIONS:
            return {
                ...state,
                allProvisions: action.payload
            };
        case Types.PROVISION_ADD_NEW:
            return {
                ...state,
                newProvision: action.payload
            };
        case Types.PROVISION_LOGS:
            return {
                ...state,
                logs: action.payload
            };
        case Types.PROVISION_COST_AND_SECURITY:
            return {
                ...state,
                allCostAndSecurity: action.payload
            };
        case Types.PROVISION_RESET:
            return initialState;
        default:
            return state;
    }
}
